import React, { useState } from "react";
import { TextField, Tooltip } from "@mui/material";
import { TextFieldForViewOnly } from "./TextField";
import { formatAmount } from "../../../utils/hooks/dataHandler";

const DecimalTextField = ({
  value,
  onChange,
  decimalPlaces = 2,
  maxValue,
  warningMessage,
  reference,
  textAlign = "right",
  disabled = false,
  maxLength = 15,
  canEdit = true,
}) => {
  const [warning, setWarning] = useState(false);

  const handleChange = (event) => {
    setWarning(false);
    const inputValue = event.target.value;

    // Allow empty input
    if (inputValue === "") {
      onChange("", reference);
      return;
    }

    // Allow input like ".", "0.", "88.", etc. and enforce decimalPlaces
    const decimalRegex = new RegExp(`^\\d*(\\.\\d{0,${decimalPlaces}})?$`);
    if (!decimalRegex.test(inputValue)) {
      setWarning(true);
      return;
    }

    // Only check maxValue if the input is a valid number AND doesn't end with a dot (intermediate input)
    const endsWithDot = inputValue.endsWith(".");
    const numericValue = parseFloat(inputValue);
    if (
      !isNaN(numericValue) &&
      !endsWithDot &&
      maxValue !== undefined &&
      maxValue !== null &&
      numericValue > maxValue
    ) {
      setWarning(true);
      return;
    }

    onChange(inputValue, reference);
  };

  if (!canEdit) {
    return (
      <TextFieldForViewOnly
        value={formatAmount(value, false)}
        sx={{ textAlign }}
      />
    );
  }

  return (
    <Tooltip
      title={warning ? warningMessage || `Value cannot exceed ${maxValue}` : ""}
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: "red",
            color: "white",
          },
        },
      }}
    >
      <TextField
        value={value}
        onChange={handleChange}
        inputProps={{
          maxLength: maxLength,
          style: { textAlign },
          autoComplete: "off",
          step: "any",
        }}
        variant='outlined'
        error={warning}
        size='small'
        disabled={disabled}
        sx={{ backgroundColor: "white" }}
      />
    </Tooltip>
  );
};

export default DecimalTextField;
